export class LinklyError extends Error {
  constructor(...args: any) {
    super(...args);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class InvalidOperationException extends LinklyError {}

export class ArgumentOutOfRangeException extends LinklyError {}
